export default __webpack_public_path__ + "static/media/void.5c1957d5.svg";